import styled from 'styled-components';
import { WppTypography } from '@wppopen/components-library-react';

export const InputCheckbox = styled.input.attrs({ type: 'checkbox' })`
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
`;

export const Label = styled(WppTypography)<{ checked: boolean }>`
    width: max-content;
    opacity: ${({ checked = true }) => (checked ? 1 : 0.35)};

    &:hover {
        color: #4d5358;
    }
`;

export const SpanContainer = styled.span<{
    checked?: boolean;
    checkboxColor: string;
}>`
    height: 10px;
    width: 10px;
    background-color: ${({ checkboxColor }) => checkboxColor};
    opacity: ${({ checked = true }) => (checked ? 1 : 0.35)};
`;

export const Container = styled.label<{
    checked: boolean;
    checkboxColor: string;
    visibility: string;
}>`
    display: grid;
    grid-template-columns: 10px auto;
    column-gap: 6px;
    visibility: ${(props: any) => props.visibility};
    align-items: center;
    position: relative;
    margin: 0;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    & ${InputCheckbox} ~ ${SpanContainer} {
        background-color: ${(props: any) => props.checked && props.checkboxColor};
        border-radius: 50%;
    }
`;
